import Login from './login'
import SignUp from './signup'

const Public = { Login, SignUp }

export { Public }
